import { ObservationsRepository } from '@/io/repository/ObservationsRepository';
import {
  CreateNurseNotice,
  DeleteNurseNotice,
} from '@/models/NurseNoticeModel';
import { PractitionerQueries } from '@/queries/PractitionerQueries';
import { createMutation } from '@/queries/utils/CreateMutation';

import { AlertsQueries } from './AlertsQueries';

export class ObservationsQueries {
  constructor(
    private readonly practitioners: PractitionerQueries = new PractitionerQueries(),
    private readonly observations: ObservationsRepository = new ObservationsRepository(),
    private readonly alerts: AlertsQueries = new AlertsQueries(),
  ) {}

  /*******************************/
  /********** MUTATIONS **********/
  /*******************************/

  useCreateNotice = createMutation(
    'create-notice',
    async (data: CreateNurseNotice) => this.observations.createNotice(data),
    {
      onSuccess: (_, requestData, { queryClient }) => {
        this.practitioners.usePatientsList.invalidate(queryClient, {});
        this.practitioners.useNurseNotice.invalidate(
          queryClient,
          requestData.patient_id,
        );
      },
    },
  );

  useDeleteNotice = createMutation(
    'delete-notice',
    async (data: DeleteNurseNotice) => this.observations.deleteNotice(data),
    {
      onSuccess: (_, requestData, { queryClient }) => {
        this.practitioners.usePatientsList.invalidate(queryClient, {});
        this.practitioners.useNurseNotice.invalidate(
          queryClient,
          requestData.patient_id,
        );
      },
    },
  );

  useMitigateNotice = createMutation(
    'mitigate-notice',
    async (data: DeleteNurseNotice) => this.observations.mitigateNotice(data),
    {
      onSuccess: (_, requestData, { queryClient }) => {
        this.practitioners.usePatientsList.invalidate(queryClient, {});
        this.practitioners.useNurseNotice.invalidate(
          queryClient,
          requestData.patient_id,
        );
        this.alerts.useListPatientAlerts.invalidate(
          queryClient,
          requestData.patient_id,
        );
      },
    },
  );
}
